export default function MySQL_SELFJOIN() {
  return (
    <div>
      <h2>MySQL_SELFJOIN</h2>    </div>
  );
}